module.exports = __webpack_public_path__ + "static/media/contact-hero.94396aa8.jpg";